import fetchRedux from "../../api/fetch_redux";
import { toast } from "react-toastify";
import { setAguardar } from "./aguardar-actions";
import { ToastErro } from "../../utils/utils";

export const MANUTENCAO_USUARIOS_INIT = "MANUTENCAO_USUARIOS_INIT";
export const MANUTENCAO_USUARIOS_GESTAO_USUARIO =
  "MANUTENCAO_USUARIOS_GESTAO_USUARIO";
export const MANUTENCAO_USUARIOS_EXCLUIR_USUARIO =
  "MANUTENCAO_USUARIOS_EXCLUIR_USUARIO";
export const MANUTENCAO_REGIOES_INIT = "MANUTENCAO_REGIOES_INIT"; // Para recuperar os dados relacionados as regioes
export const MANUTENCAO_REGIOES_ADD_REGIAO_LOCALIDADE =
  "MANUTENCAO_REGIOES_ADD_REGIAO_LOCALIDADE"; // Para adicionar as regioes
export const MANUTENCAO_REGIOES_DEL_REGIAO_LOCALIDADE =
  "MANUTENCAO_REGIOES_DEL_REGIAO_LOCALIDADE"; // Para excluir uma localidade
export const MANUTENCAO_REGIOES_UPD_REGIAO_LOCALIDADE =
  "MANUTENCAO_REGIOES_UPD_REGIAO_LOCALIDADE"; // Para editar uma regiao ja cadastrada
export const MANUTENCAO_REGIOES_ADD_REGIAO = "MANUTENCAO_REGIOES_ADD_REGIAO"; // usada para adicionar uma regiao na lista de regioes
export const MANUTENCAO_VARIAVEIS_INIT = "MANUTENCAO_VARIAVEIS_INIT"; // Recuperar os dados referentes as variaveis
export const MANUTENCAO_VARIAVEIS_ADD_VARIAVEL =
  "MANUTENCAO_VARIAVEIS_ADD_VARIAVEL"; // Para adicionar uma nova variavel
export const MANUTENCAO_VARIAVEIS_UPD_VARIAVEL =
  "MANUTENCAO_VARIAVEIS_UPD_VARIAVEL"; // Para editar uma variavel por completo
export const MANUTENCAO_VARIAVEIS_DEL_VARIAVEL =
  "MANUTENCAO_VARIAVEIS_DEL_VARIAVEL"; // Para excluir a variavel
export const MANUTENCAO_VARIAVEIS_UPD_VALOR_VARIAVEL =
  "MANUTENCAO_VARIAVEIS_UPD_VALOR_VARIAVEL"; // Para atualizar o valor de uma variavel
export const MANUTENCAO_CARGO_INIT = "MANUTENCAO_CARGO_INIT"; // Para controlar a recuperacao ded todos os cargos
export const MANUTENCAO_CARGO_ADD = "MANUTENCAO_CARGO_ADD"; // Para adicionar um novo cargo
export const MANUTENCAO_CARGO_UPD = "MANUTENCAO_CARGO_UPD"; // Para alterar um cargo
export const MANUTENCAO_CARGO_DEL = "MANUTENCAO_CARGO_DEL"; // Para excluir um cargo
export const MANUTENCAO_SET_DRAWER = "MANUTENCAO_SET_DRAWER"; // Esta action define o valor do drawer a ser exibido

const ROTAS = [
  "/usuario",
  "/cadastro_usuario",
  "/manutencao_de_regioes",
  "/parametros_da_aplicacao",
  "/curriculo_cargo",
];

// faz a achamada inicial para obter todos os usuarios cadastrados da plataforma
export const manutencaoUsuariosGetInit = () => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[0],
    "GET",
    null,
    (resp) => {
      // Tudo certo vamos montar os dados
      dispatch({
        type: MANUTENCAO_USUARIOS_INIT,
        data: resp,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
// Recebe o parametro e passa para a funcao que libera o usuario ou torna-o admin
export const manutencaoUsuariosGestaoUsuario = (obj) => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[0],
    "PUT",
    obj,
    (resp) => {
      // Tudo certo vamos atualizar os usuario
      dispatch({
        type: MANUTENCAO_USUARIOS_GESTAO_USUARIO,
        data: { data: resp.data, id_usuario: obj.id_usuario },
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
// Recebe o parametro e atualiza a senha do usuario
export const manutencaoUsuariosAtualizarSenha = (obj) => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[0],
    "PATCH",
    obj,
    (resp) => {
      // Tudo certo, exibe mensagem de sucesso
      toast(resp.sucesso, {
        position: "bottom-center",
        style: {
          backgroundColor: "#141414",
          color: "white",
        },
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
// action para exclusao de um usuario
export const manutencaoUsuariosExcluirUsuario = (obj) => (dispatch) => {
  if (!window.confirm("Tem certeza que deseja excluir o usuário ?"))
    return false;

  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[0],
    "DELETE",
    obj,
    (resp) => {
      toast.dark(resp.sucesso, {
        type: "success",
        position: "bottom-center",
        style: {
          backgroundColor: "#141414",
          color: "white",
        },
      });
      // Tudo certo vamos atualizar os usuarios
      dispatch({
        type: MANUTENCAO_USUARIOS_EXCLUIR_USUARIO,
        data: obj.id_usuario,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
// Action para criar um novo usuario
export const manutencaoUsuariosAdicionarUsuario = (obj) => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[1],
    "POST",
    obj,
    (resp) => {
      toast.dark(resp.sucesso, {
        type: "success",
        position: "bottom-center",
      });
      // Tudo certo vamos atualizar para a nova lista de usuarios
      dispatch(manutencaoUsuariosGetInit());
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
// Action para recuperar todos os dados referentes as regiões
export const manutencaoRegioesGetInit = () => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[2],
    "GET",
    null,
    (resp) => {
      // Tudo certo vamos montar os dados
      dispatch({
        type: MANUTENCAO_REGIOES_INIT,
        data: resp,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
// Action para adicionar ou editar uma regiao/localidade { regiao: '', localidade: ''} / {id_localidade, regiao, localidade}
export const manutencaoRegioesAddUpdRegiaoLocalidade =
  (obj, editar) => (dispatch) => {
    dispatch(setAguardar(true));

    fetchRedux(
      ROTAS[2],
      editar ? "PUT" : "POST",
      obj,
      (resp) => {
        // Tudo certo, vamos passar os dados para a loja
        toast.dark(resp.sucesso, {
          type: "success",
        });

        //if(fnFechar) fnFechar();
        dispatch(manutencaoSetDrawer(null));

        dispatch({
          type: editar
            ? MANUTENCAO_REGIOES_UPD_REGIAO_LOCALIDADE
            : MANUTENCAO_REGIOES_ADD_REGIAO_LOCALIDADE,
          data: resp.data,
        });
      },
      () => dispatch(setAguardar(false)),
      (err) => ToastErro(err)
    );
  };
// Action para excluir uma regiao/localidade { id_localidade }
export const manutencaoRegioesDelRegiaoLocalidade = (obj) => (dispatch) => {
  if (!window.confirm("Tem certeza que deseja excluir o a localidade ?"))
    return false;

  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[2],
    "DELETE",
    obj,
    (resp) => {
      toast.dark(resp.sucesso, {
        type: "success",
      });
      // Tudo certo vamos atualizar os DADOS
      dispatch({
        type: MANUTENCAO_REGIOES_DEL_REGIAO_LOCALIDADE,
        data: obj.id_localidade,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
// Action para adicionar uma regiao no state atual
export const manutencaoRegioesAddRegiao = (valor) => ({
  type: MANUTENCAO_REGIOES_ADD_REGIAO,
  data: valor,
});
// Action para determinar o drawer que deve ser exibido
export const manutencaoSetDrawer = (valor) => ({
  type: MANUTENCAO_SET_DRAWER,
  data: valor,
});
// Action para recuperar todos os dados referentes as variaveis
export const manutencaoVariaveisGetInit = () => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[3],
    "GET",
    null,
    (resp) => {
      // Tudo certo vamos montar os dados
      dispatch({
        type: MANUTENCAO_VARIAVEIS_INIT,
        data: resp,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
// Action para adicionar uma nova variavel no projeto
export const manutencaoVariaveisAddUpdVariavel =
  (obj, editar) => (dispatch) => {
    dispatch(setAguardar(true));

    fetchRedux(
      ROTAS[3],
      editar ? "PUT" : "POST",
      obj,
      (resp) => {
        toast.dark(resp.sucesso, { type: "success" });
        // Fechar o drawer/dialog
        dispatch(manutencaoSetDrawer(null));
        // Se tudo ocorreu bem entao devemos inserir o novo registro na tabela
        dispatch({
          type: editar
            ? MANUTENCAO_VARIAVEIS_UPD_VARIAVEL
            : MANUTENCAO_VARIAVEIS_ADD_VARIAVEL,
          data: resp.data,
        });
      },
      () => dispatch(setAguardar(false)),
      (err) => ToastErro(err)
    );
  };
//
export const manutencaoVariaveisUpdValor = (obj) => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[3],
    "PATCH",
    obj,
    (resp) => {
      toast.dark(resp.sucesso, { type: "success" });
      // Fechar o drawer/dialog
      dispatch(manutencaoSetDrawer(null));
      // Se tudo ocorreu bem entao devemos inserir o novo registro na tabela
      dispatch({
        type: MANUTENCAO_VARIAVEIS_UPD_VALOR_VARIAVEL,
        data: resp.data,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
// Action para excluir uma variavel
export const manutencaoVariaveisDelVariavel = (obj) => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[3],
    "DELETE",
    obj,
    (resp) => {
      toast.dark(resp.sucesso, { type: "success" });
      // Fechar o drawer/dialog
      dispatch(manutencaoSetDrawer(null));
      // Se tudo ocorreu bem entao devemos inserir o novo registro na tabela
      dispatch({
        type: MANUTENCAO_VARIAVEIS_DEL_VARIAVEL,
        data: obj.id_parametro,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};

// Action para recuperar todos os dados referentes aos cargos
export const manutencaoCargoGetInit = () => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[4],
    "GET",
    null,
    (resp) => {
      // Tudo certo vamos montar os dados
      dispatch({
        type: MANUTENCAO_CARGO_INIT,
        data: resp,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
// Action para inserir/editar um cargo
export const manutencaoCargoAddUpd = (obj, editar) => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[4],
    editar ? "PUT" : "POST",
    obj,
    (resp) => {
      toast.dark(resp.sucesso, { type: "success" });
      // Fechar o drawer/dialog
      dispatch(manutencaoSetDrawer(null));
      // Se tudo ocorreu bem entao devemos inserir o novo registro na tabela
      dispatch({
        type: editar ? MANUTENCAO_CARGO_UPD : MANUTENCAO_CARGO_ADD,
        data: resp.data,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
// Action para excluir um cargo
export const manutencaoCargoDel = (obj) => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[4],
    "DELETE",
    obj,
    (resp) => {
      toast.dark(resp.sucesso, { type: "success" });
      // Fechar o drawer/dialog
      dispatch(manutencaoSetDrawer(null));
      // Se tudo ocorreu bem entao devemos excluir
      dispatch({
        type: MANUTENCAO_CARGO_DEL,
        data: obj.id_cargo,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
